import React, { useState } from 'react'
import { Field } from 'formik'
import { Label, Text } from '../../../ui/Typography'
import { ColorPickerRow } from '../../../ui/ColorPicker'
import { SideSelect } from '../../../ui/Select'
import ToggleRedGreen from '../../../ui/ToggleRedGreen'
import CollapsibleSection from '../../../Components/CollapsibleSection'
import { Flex } from '../../../ui/Layout'
import formikFormWrapper from '../../../formikFormWrapper.js'
import { Input, SideInput } from '../../../ui/Input'
import { TitleAlignment } from '../../Create/WidgetOptionsOptions'
import { BrandingUploader } from '../../../Account/index'
import ButtonsSection from './ButtonsSection'

const FormSideInput = formikFormWrapper(SideInput)
const FormInput = formikFormWrapper(Input)

const FullScreenSettings = ({ values, setFieldValue, selectedVideos }) => {
  const [openCollapsible, setOpenCollapsible] = useState(false)
  if (values.isNavigationCampaign) return null

  return (
    <>
      {/* BUTTONS */}
      <ButtonsSection
        values={values}
        setFieldValue={setFieldValue}
        openCollapsible={openCollapsible}
        setOpenCollapsible={setOpenCollapsible}
      />
      {/* TITLES */}
      {!values.isInlineCampaign ? (
        <CollapsibleSection
          topBorder={values.isNavigationCampaign}
          label="Titles"
          openCollapsible={openCollapsible}
          setOpenCollapsible={setOpenCollapsible}
          icon="text-white"
          iconBgColor="black"
          noContentPadding
        >
          <Flex flexDirection="column" borderBottom="1px solid rgba(237, 242, 247, 1)" pt="16px" px="24px" mb="16px">
            <Flex mb="16px" justifyContent="space-between">
              <Label mt="2px" mr="16px">
                Display title:
              </Label>
              <ToggleRedGreen
                setSelected={(selected) => {
                  setFieldValue('titleActive', selected)
                }}
                value1={false}
                value2={true}
                selected={values.titleActive}
              />
            </Flex>
            <Flex mb="16px" justifyContent="space-between">
              <Label mt="2px" mr="16px">
                Display subtitle:
              </Label>
              <ToggleRedGreen
                setSelected={(selected) => {
                  setFieldValue('subtitleActive', selected)
                }}
                value1={false}
                value2={true}
                selected={values.subtitleActive}
              />
            </Flex>
          </Flex>

          {values.titleActive || values.subtitleActive ? (
            <Flex flexDirection="column" borderBottom="1px solid rgba(237, 242, 247, 1)" mb="16px">
              <Field
                name="titleFontSize"
                label="Title Font Size"
                textPostFix="px"
                type="number"
                min="0"
                dark
                component={FormSideInput}
              />
              <Field
                name="subtitleFontSize"
                label="Subtitle Font Size"
                textPostFix="px"
                type="number"
                min="0"
                dark
                component={FormSideInput}
              />
            </Flex>
          ) : null}

          <Flex borderBottom="1px solid rgba(237, 242, 247, 1)">
            <Field
              tooltip="Font family may not display correctly in preview.<br>No value will attempt to inherit your websites default font."
              name="titleFontFamily"
              label="Font Family"
              dark
              component={FormSideInput}
            />
          </Flex>
          <TitleAlignment setFieldValue={setFieldValue} name="titleAlignment" value={values.titleAlignment} />
        </CollapsibleSection>
      ) : null}
      {/* BACKGROUND COLOR */}
      <CollapsibleSection
        label="Background Color"
        openCollapsible={openCollapsible}
        setOpenCollapsible={setOpenCollapsible}
        icon="brush-white"
        iconBgColor="black"
        noContentPadding
      >
        <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px">
          <ColorPickerRow
            label="Fullscreen Background Color"
            setFieldValue={setFieldValue}
            name="fullscreenBackgroundColor"
            value={values.fullscreenBackgroundColor}
          />
        </Flex>
      </CollapsibleSection>
      {/* SETTINGS*/}
      {!values.isInlineCampaign && !values.isNavigationCampaign ? (
        <CollapsibleSection
          label="Player Settings"
          openCollapsible={openCollapsible}
          setOpenCollapsible={setOpenCollapsible}
          icon="cog-white"
          iconBgColor="black"
          noContentPadding
        >
          <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)">
            <SideSelect
              noBorder
              label="Mobile Swipe Direction"
              width="100%"
              value={values.mobileVerticalScroll}
              onChange={(option) => setFieldValue('mobileVerticalScroll', option.value)}
              options={[
                { value: true, label: 'Vertical' },
                { value: false, label: 'Horizontal' }
              ]}
              placeholder="Select option"
            />
          </Flex>
          {selectedVideos && selectedVideos.length && selectedVideos.length > 50 ? (
            <Text px="24px" mb="16px" fontSize="12px" lineHeight="16px" light>
              For performance reasons we recommend larger campaigns use horizontal swiping.
            </Text>
          ) : null}
        </CollapsibleSection>
      ) : null}
      {/* SHOPPABLE */}
      {values.isShoppable ? (
        <CollapsibleSection
          label="Shoppable Settings"
          openCollapsible={openCollapsible}
          setOpenCollapsible={setOpenCollapsible}
          icon="cart-white"
          iconBgColor="black"
          noContentPadding
        >
          <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px" px="24px">
            <Field mb="24px" name="addToCartText" label="Add To Cart Button Label" dark component={FormInput} />
          </Flex>

          <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px" px="24px">
            <Field mb="24px" name="deliveryMessage" label="Delivery Message" dark component={FormInput} />
          </Flex>
        </CollapsibleSection>
      ) : null}
      {/* SHARING */}
      <CollapsibleSection
        label="Sharing Label"
        openCollapsible={openCollapsible}
        setOpenCollapsible={setOpenCollapsible}
        icon="share-white"
        iconBgColor="black"
        noContentPadding
      >
        <Flex flexDirection="column" borderTop="1px solid rgba(237, 242, 247, 1)" pt="16px" px="24px">
          <Field mb="24px" name="sharingTitle" label="Sharing Meta Title" dark component={FormInput} />
        </Flex>
      </CollapsibleSection>
    </>
  )
}

export default FullScreenSettings
